import { ClientCartAddress_Second } from "@swo/storefront";
import { InternationalPhoneNumber } from "./international-phone-number/international-phone-number";

export type InternalAddress = {
  addressLineOne: string;
  addressLineTwo: string | undefined;

  postalCode: string;
  city: string;
  state?: string; // only for US and CA
  country: string;

  phoneNumber: InternationalPhoneNumber;

  // only for shipping address
  email?: string;
  firstName?: string;
  lastName?: string;
};

export function ctpAddressToInternalAddress(
  address: ClientCartAddress_Second & { email?: string; firstName?: string; lastName?: string },
  country: { isoCode: string; label: string },
  canEditUserEmail: boolean,
): InternalAddress {
  return {
    firstName: address.firstName,
    lastName: address.lastName,

    addressLineOne: address.streetName || "",
    addressLineTwo: address.additionalAddressInfo,
    postalCode: address.postalCode || "",
    state: address.state || "",
    city: address.city || "",
    country: country.isoCode.toUpperCase(),
    phoneNumber: InternationalPhoneNumber.fromString(address.phone, country.isoCode) || {
      countryIsoCode: country.isoCode,
      localPhoneNumber: "",
    },
    email: canEditUserEmail ? address.email : undefined,
  };
}

export function emptyInternalAddressFactory(
  country: { isoCode: string; label: string },
  canEditUserEmail: boolean,
): InternalAddress {
  return {
    // firstName: "",
    // lastName: "",
    addressLineOne: "",
    addressLineTwo: "",
    postalCode: "",
    state: "",
    city: "",
    country: country.isoCode.toUpperCase(),
    phoneNumber: {
      countryIsoCode: country.isoCode,
      localPhoneNumber: "",
    },
    email: canEditUserEmail ? "" : undefined,
  };
}
